import React from 'react';
import ProductsData from '../../Data/Products';
import { FaStar } from 'react-icons/fa';
import { Helmet } from 'react-helmet';

const Products = () => {
  return (
    <section className="py-20 bg-gray-900">
      <Helmet>
        <title>Digital Products | Mern Digital</title>
        <meta name="description" content="Explore our range of premium digital products designed to enhance your business operations and drive growth." />
        <link rel="canonical" href="https://merndigital.com/products" />
      </Helmet>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Our <span className="bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text font-semibold text-transparent">Digital Products</span>
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Premium solutions designed and developed to power your digital transformation 
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 ">
          {ProductsData.map((product, index) => (
            <div
              key={index}
              className="w-[420px] group relative bg-gray-800 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-700 hover:border-indigo-400/30"
            >
              {product.popular && (
                <div className="absolute top-3 right-3 bg-gradient-to-r from-indigo-500 to-purple-600 text-white text-xs font-bold px-3 py-1 rounded-full z-10 shadow-lg flex items-center">
                  <FaStar className='pr-1 h-4 w-4'/>
                  POPULAR
                </div>
              )}
              
              {/* Product Image */}
              <div className="overflow-hidden h-48 bg-gray-700">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 opacity-90 group-hover:opacity-100"
                />
              </div>

              {/* Rest of the product card remains the same */}
              <div className="p-6">
                <div className="flex justify-between items-start mb-3">
                  <h3 className="text-xl font-bold text-white group-hover:text-indigo-400 transition-colors">
                    {product.name}
                  </h3>
                  {product.price && (
                    <span className="bg-indigo-900/50 text-indigo-300 px-3 py-1 rounded-full text-sm font-medium">
                      ${product.price}
                    </span>
                  )}
                </div>

                {product.description && (
                  <p className="text-gray-400 mb-4 text-sm">{product.description}</p>
                )}

                <div className="space-y-4">
                  {Object.entries(product.TechStack).map(([category, items], idx) => (
                    <div key={idx}>
                      <p className="text-xs font-semibold text-indigo-400 uppercase tracking-wider mb-1">
                        {category}
                      </p>
                      <div className="flex flex-wrap gap-2">
                        {items.map((item, i) => (
                          <span 
                            key={i} 
                            className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-700 text-gray-200"
                          >
                            {item}
                          </span>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>

                {/* <div className="mt-6 inline-flex gap-3 w-full">
                  <button className="w-full py-2 px-4 border border-indigo-600 rounded-md shadow-sm text-sm font-medium text-indigo-300 bg-transparent hover:bg-indigo-600 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors">
                    View Live Demo
                  </button>
                  <button className="w-full py-2 px-4 border border-indigo-600 rounded-md shadow-sm text-sm font-medium text-indigo-300 bg-transparent hover:bg-indigo-600 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors">
                    View Gallery
                  </button>
                </div> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;